import { userSession } from '@/api/modules/login.api.js';
import { currentDomainOrganisation } from '@/api/modules/app.api.js';
import Config from '@/services/config.service';
const appConfig = new Config();

function checkAccessToGroups(to, from, next) {
  if (userSession.isSuperuser() && !appConfig.isSaas) {
    return next();
  }
  if (appConfig.isSaas && currentDomainOrganisation.value) {
    return next({
      name: 'OrganisationDetail',
      params: {
        locale: to.params.locale,
        id: currentDomainOrganisation.value.id,
      },
    });
  }
  return next({
    name: '403Page',
    params: {
      locale: to.params.locale,
    },
  });
}

export default [
  // Groupes d'utilisateurs
  {
    path: 'accounts/groups',
    name: 'Groups',
    component: () => import('./views/Groups/Groups.vue'),
    beforeEnter: checkAccessToGroups,
  },
  {
    path: 'accounts/groups/new',
    name: 'AddGroup',
    component: () => import('./views/Groups/AddGroup.vue'),
    beforeEnter: checkAccessToGroups,
  },
  {
    path: 'accounts/groups/:id',
    name: 'GroupDetail',
    component: () => import('./views/Groups/GroupDetail.vue'),
    beforeEnter: checkAccessToGroups,
  },
  // Groupes d'organisations
  {
    path: 'accounts/spheres',
    name: 'Spheres',
    component: () => import('./views/Spheres/Spheres.vue'),
    beforeEnter: checkAccessToGroups,
  },
  {
    path: 'accounts/spheres/new',
    name: 'AddSphere',
    component: () => import('./views/Spheres/AddSphere.vue'),
    beforeEnter: checkAccessToGroups,
  },
  {
    path: 'accounts/spheres/:id',
    name: 'SphereDetail',
    component: () => import('./views/Spheres/SphereDetail.vue'),
    beforeEnter: checkAccessToGroups,
  }
];
